import React, { useState, useCallback, useEffect } from 'react';

import HeaderSection from '../HeaderSection';

import style from './style.module.scss';

export default function HeaderResourcesSection({
    title,
    subtitle,
    categories,
    tabItems,
    allCategoriesTitle,
    filterCategoriesTitle,
    onFilterChange,
    extraContent,
    colorScheme,
}) {
    colorScheme = colorScheme?.toLowerCase();
    const [activeTitle, setActiveTitle] = useState(
        tabItems && tabItems.length ? tabItems[0].label : null
    );

    useEffect(() => {
        if (!categories || !categories.length) {
            return;
        }

        const onHashChangeListener = () => {
            const hash = window.location.hash
                ? window.location.hash.replace('#', '')
                : '';
            if (hash && categories.find((c) => c.slug === hash)) {
                let item = categories.find((c) => c.slug === hash);
                setActiveTitle(item.title);
                if (onFilterChange) {
                    onFilterChange(item);
                }
            } else {
                setActiveTitle(null);
                if (onFilterChange) {
                    onFilterChange(null);
                }
            }
        };

        onHashChangeListener();
        window.addEventListener('hashchange', onHashChangeListener);

        return () => {
            window.removeEventListener('hashchange', onHashChangeListener);
        };
    }, [setActiveTitle, categories, onFilterChange, onFilterChange]);

    const getCategoryTabItems = useCallback(() => {
        if (tabItems && tabItems.length) {
            return tabItems.map((t, i) => ({
                active: i ? false : true,
                title: t.label,
                href: t.externalLink,
            }));
        } else if (categories && categories.length) {
            return [
                {
                    active: !activeTitle,
                    title: allCategoriesTitle,
                    href: '#all',
                },
                ...categories.map((c) => ({
                    active: activeTitle === c.title,
                    title: c.title,
                    href: `#${c.slug}`,
                })),
            ];
        }

        return [];
    }, [categories, allCategoriesTitle, activeTitle, tabItems]);

    return (
        <HeaderSection
            colorScheme={colorScheme}
            title={title}
            titleTag="h1"
            subtitle={subtitle}
            showSubpagesMenu={true}
            subtitleClassName="h4"
            tabItems={getCategoryTabItems()}
            activeTabTitle={activeTitle ? activeTitle : allCategoriesTitle}
            closeModalOnHashChange={true}
            tabItemsTitle={filterCategoriesTitle}
            tabSectionPt={
                !colorScheme || colorScheme === 'none' ? { xs: 0 } : null
            }
            tabClassName={style.tabs}
            tabLinkClassName={style['tabs__link']}
            tabLinkActiveClassName={style['tabs__link--active']}
            extraContent={extraContent}
        />
    );
}
